<template>
  <div class="supercontainer-COMODO">
    <div class="container-general-COMODO">
      <h2 class="COMODOBannerOf-title">
        {{ title }}
      </h2>
      <div class="COMODOBannerOf-container">
        <div class="container-column-COMODO">
          <div class="COMODOBannerOf-text">
            <ul class="img-container">
              <li
                v-for="(text, index) in subtitle"
                :key="index"
                class="list-item"
              >
                <img
                  alt="Icono Bullet"
                  class="bbva-COMODO-icon"
                  src="@/assets/img/1x/li-azul.png"
                />
                <span>
                  {{ text }}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="bbva-COMODO">
          <img
            alt="Banner Comodidad BBVA "
            src="../../../assets/bannerComodidad.png"
            class="bbva-COMODO-img"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerMasComodo",
  props: {
    title: String,
    subtitle: Array
  }
};
</script>

<style scoped>
.supercontainer-COMODO {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  padding: 20px;
}

.container-general-COMODO {
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.COMODOBannerOf-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 0 80px 0;
}

.container-column-COMODO {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.COMODOBannerOf-text {
  text-align: center;
}

.COMODOBannerOf-text ul li span {
  max-width: 376px;
  width: 100%;
  text-align: left;
  white-space: normal;
}

.COMODOBannerOf-title {
  font-size: 36px;
  font-weight: 500;
  color: #000;
  margin-bottom: 15px;
  text-align: center;
  padding: 40px 0;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.img-container {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #333;
  font-size: 15px;
}

.bbva-COMODO-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  position: relative;
}

.bbva-COMODO {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.bbva-COMODO-img {
  max-width: 446px;
  width: 100%;
  height: auto;
}

@media (max-width: 600px) {
  .supercontainer-COMODO {
    max-height: 138px;
    margin-top: 8px;
  }

  .COMODOBannerOf-text ul li span {
    font-size: 12px;
    max-width: 260px;
  }
}

@media (max-width: 768px) {
  div.bbva-COMODO {
    display: none;
  }
  .COMODOBannerOf-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;
  }

  .COMODOBannerOf-title {
    font-size: 12px;
    padding: 0;
  }

  .COMODOBannerOf-container .list-item {
    margin-bottom: 2px;
  }
  .bbva-COMODO {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .bbva-COMODO-img {
    max-width: 150px;
  }
}
</style>
